import { IconType } from "react-icons";
import { RxDashboard } from "react-icons/rx";
import { IoInvertModeOutline } from "react-icons/io5";
import { FaMapLocationDot } from "react-icons/fa6";
import { TbHomePlus } from "react-icons/tb";
import { BiSolidBookAdd } from "react-icons/bi";
import { IoIosBook } from "react-icons/io";
import { VscFileSubmodule } from "react-icons/vsc";
import { HiMiniLockOpen } from "react-icons/hi2";
import { SiGoogletranslate } from "react-icons/si";
import { FaStackExchange } from "react-icons/fa6";
import { RiCoupon4Line } from "react-icons/ri";
import { UserModuleNameTypes } from "./models/userAccess/UserAccess.model";
import { GrChapterAdd } from "react-icons/gr";



type NavItemTypeWithoutChild = {
  label: string;
  moduleName: string;
  path: string;
  icon: IconType;
  children?: never;
};

type NavItemTypeWithChild = {
  label: string;
  moduleName: string;
  path?: never;
  icon: IconType;
  children?: {
    label: string;
    moduleName: string;
    path: string;
    icon: IconType;
  }[];
};

export type NavItemType = NavItemTypeWithChild | NavItemTypeWithoutChild;

export const configurationNavigation: NavItemType[] = [
  {
    label: "Modes",
    icon: IoInvertModeOutline,
    moduleName: UserModuleNameTypes.MODES,
    path: "modes",
  },
  {
    label: "Disposition",
    icon: RxDashboard,
    moduleName: UserModuleNameTypes.DISPOSITION,
    path: "dispositions",
  },
  {
    label: "Locations",
    icon: FaMapLocationDot,
    moduleName: UserModuleNameTypes.LOCATIONS,
    path: "locations",
  },
  {
    label: "Branches",
    icon: TbHomePlus,
    moduleName: UserModuleNameTypes.BRANCHES,
    path: "branches",
  },
  {
    label: "Courses",
    icon: BiSolidBookAdd,
    moduleName: UserModuleNameTypes.COURSES,
    path: "courses",
  },
  {
    label: "Modules Chapter",
    icon: GrChapterAdd,
    moduleName: UserModuleNameTypes.COURSES,
    path: "modules-chapter",
  },
  {
    label: "Chapters",
    icon: IoIosBook,
    moduleName: UserModuleNameTypes.CHAPTERS,
    path: "chapters",
  },
  {
    label: "Modules",
    icon: VscFileSubmodule,
    moduleName: UserModuleNameTypes.MODULES,
    path: "modules",
  },

  {
    label: "Holiday Calendar",
    icon: HiMiniLockOpen,
    moduleName: UserModuleNameTypes.HOLIDAY_CALENDAR,
    path: "holiday-calendar",
  },
  {
    label: "Language",
    icon: SiGoogletranslate,
    moduleName: UserModuleNameTypes.LANGUAGE,
    path: "language",
  },
  {
    label: "Communication Method",
    icon: FaStackExchange,
    moduleName: UserModuleNameTypes.COMMUNICATION_METHOD,
    path: "communication-method",
  },
 {
    label: "Inquiry Labels",
    icon: RiCoupon4Line,
    moduleName: UserModuleNameTypes.COUPONS,
    path: "inqury-labels",
  },
];
